import { SettingsApiDataSource } from "../data/datasources/SettingsApiDataSource";
import { SettingsRepositoryImpl } from "../data/repositories/SettingsRepositoryImpl";
import { GetCompanySettingsUseCase } from "../domain/usecases/GetCompanySettingsUseCase";
import { UpdateCompanySettingsUseCase } from "../domain/usecases/UpdateCompanySettingsUseCase";
import { GetGstSettingsUseCase } from "../domain/usecases/GetGstSettingsUseCase";
import { UpdateGstSettingsUseCase } from "../domain/usecases/UpdateGstSettingsUseCase";
import { GetGstZohoStatusUseCase } from "../domain/usecases/GetGstZohoStatusUseCase";
import { SyncGstTaxesUseCase } from "../domain/usecases/SyncGstTaxesUseCase";
import { RunGstChecksUseCase } from "../domain/usecases/RunGstChecksUseCase";
import { UseZohoGstinUseCase } from "../domain/usecases/UseZohoGstinUseCase";

/**
 * Wiring for the settings feature.
 *
 * Mirrors `features/home/di/container.ts`: singletons built once at module
 * load, use cases exposed as factories so hooks keep stable references.
 */
class SettingsContainer {
  private readonly dataSource = new SettingsApiDataSource();
  private readonly repository = new SettingsRepositoryImpl(this.dataSource);
  private readonly getCompanySettingsUseCase = new GetCompanySettingsUseCase(this.repository);
  private readonly updateCompanySettingsUseCase = new UpdateCompanySettingsUseCase(this.repository);
  private readonly getGstSettingsUseCase = new GetGstSettingsUseCase(this.repository);
  private readonly updateGstSettingsUseCase = new UpdateGstSettingsUseCase(this.repository);
  // ZOUR-19.
  private readonly getGstZohoStatusUseCase = new GetGstZohoStatusUseCase(this.repository);
  private readonly syncGstTaxesUseCase = new SyncGstTaxesUseCase(this.repository);
  private readonly runGstChecksUseCase = new RunGstChecksUseCase(this.repository);
  private readonly useZohoGstinUseCase = new UseZohoGstinUseCase(this.repository);

  getCompanySettings(): GetCompanySettingsUseCase {
    return this.getCompanySettingsUseCase;
  }

  updateCompanySettings(): UpdateCompanySettingsUseCase {
    return this.updateCompanySettingsUseCase;
  }

  getGstSettings(): GetGstSettingsUseCase {
    return this.getGstSettingsUseCase;
  }

  updateGstSettings(): UpdateGstSettingsUseCase {
    return this.updateGstSettingsUseCase;
  }

  getGstZohoStatus(): GetGstZohoStatusUseCase {
    return this.getGstZohoStatusUseCase;
  }

  syncGstTaxes(): SyncGstTaxesUseCase {
    return this.syncGstTaxesUseCase;
  }

  runGstChecks(): RunGstChecksUseCase {
    return this.runGstChecksUseCase;
  }

  useZohoGstin(): UseZohoGstinUseCase {
    return this.useZohoGstinUseCase;
  }
}

export const settingsContainer = new SettingsContainer();
